import axios from 'axios';
export default {
	init() {
		return axios.get('/apps/appraiser/api/appraiser/init');
	},
	send(type, params) {
		return axios.post(`/apps/appraiser/api/appraiser/${type}`, params);
	},
	getSettlements(zipCode) {
		return axios.get('/apps/postcodes/api/get', {
			params: {
				requestValue: zipCode
			}
		});
	},
	getCaptcha() {
		return axios.get('/apps/appraiser/api/appraiser/captcha');
	}
};
